import { createAsyncThunk } from '@reduxjs/toolkit';
import { prescriptionSerive } from '../../services';

const getPrescriptionPerformance = createAsyncThunk(
    'prescription/getPrescriptionPerformance',
    async (payload, thunkAPI) => {
        try {
            const response = await prescriptionSerive.prescriptionPerformance(payload.companyId, payload.dateRange);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPrescriptionPerformanceByYear = createAsyncThunk(
    'prescription/getPrescriptionPerformanceByYear',
    async (payload, thunkAPI) => {
        try {
            const response = await prescriptionSerive.prescriptionPerformanceByYear(payload.companyId, payload.year);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getProfileData = createAsyncThunk(
    'prescription/getProfileData',
    async (payload, thunkAPI) => {
        try {
            const response = await prescriptionSerive.profileData(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const exportProfileData = createAsyncThunk(
    'prescription/exportProfileData',
    async (payload, thunkAPI) => {
        try {
            const response = await prescriptionSerive.exportProfileData(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export { getPrescriptionPerformance, getPrescriptionPerformanceByYear, getProfileData,exportProfileData };
